import { useEffect } from 'react';
import { RadioButtonGroup, useFormContext } from 'react-hook-form-mui';

type TierScope = 'type' | 'subtype';

interface PriceTierScopeFormValues {
    tierScope: TierScope;
    productTypeId: number | null;
    productSubtypeId: number | null;
}

interface Props {
    disabled?: boolean;
}

const OPTIONS: Array<{ id: TierScope; label: string }> = [
    {
        id: 'type',
        label: 'Product Type',
    },
    {
        id: 'subtype',
        label: 'Product Subtype',
    },
];

export function PriceTierScopeInput({ disabled = false }: Props) {
    const formContext = useFormContext<PriceTierScopeFormValues>();
    const tierScope = formContext.watch('tierScope');

    useEffect(() => {
        if (tierScope) {
            return;
        }

        const defaultScope: TierScope =
            formContext.getValues('productSubtypeId') != null
                ? 'subtype'
                : 'type';

        formContext.setValue('tierScope', defaultScope, {
            shouldDirty: false,
        });
    }, [formContext, tierScope]);

    return (
        <RadioButtonGroup
            name="tierScope"
            label="Assignment Scope"
            row
            options={OPTIONS}
            valueKey="id"
            labelKey="label"
            disabled={disabled}
            onChange={value => {
                const nextScope: TierScope =
                    value === 'subtype' ? 'subtype' : 'type';

                if (nextScope === 'type') {
                    formContext.setValue('productSubtypeId', null);
                    return;
                }

                formContext.setValue('productTypeId', null);
            }}
        />
    );
}
